// extracted by mini-css-extract-plugin
export default {"root":"StoreBadges_root__bAf-1","appStoreBadge":"StoreBadges_appStoreBadge__egaJy","googlePlayBadge":"StoreBadges_googlePlayBadge__1UtK7"};